import { useIntl } from 'platform-components';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useMount } from 'react-use';
import { useHistory } from 'react-router';

import qs from 'query-string';
import { TeacherKPKPage as ModulesTeacherKPKsPage } from '@edu-frontend/modules/src/pages/teacherKPKPage';
import { getIsTeacher } from 'platform-components/src/components/user/selectors';

import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';
import { scrollTo } from 'utils/scroll-to';

import { actions } from './lib/store/actions';
import { teacherKPKsSelectors } from './lib/store/selectors';
import { useJoinCodeProps, useTeacherKPKPageActions } from './lib/hooks';

import './teacher-kpks-page.css';

export const TeacherKPKsPage = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const pageTitle = intl.formatMessage({ id: 'teacherTrainingCourses.pageTitle' });

    useMount(() => {
        scrollTo(0, 0);
        dispatch(actions.getTeacherKPKsRequest());
    });

    const KPKs = useSelector(teacherKPKsSelectors.getTeacherKPKsByClass);
    const KPKsLoading = useSelector(teacherKPKsSelectors.getGetTeacherKPKsLoading);
    const KPKsStream = useSelector(teacherKPKsSelectors.getTeacherKPKsStream);

    const teacherKPKPageActions = useTeacherKPKPageActions();
    const joinCodeProps = useJoinCodeProps();

    const isTeacher = useSelector(getIsTeacher);

    // Прокидываем deleteParamFromQuery из плюкера, тк версия react-router отличается от modules
    const history = useHistory();
    const deleteParamFromQuery = (param: string) => {
        const newQuery = { ...qs.parse(history.location.search) };
        delete newQuery[param];
        history.replace({ search: qs.stringify(newQuery) }, { replace: true });
    };

    return (
        <>
            <Helmet title={pageTitle} />
            <TeacherHeader hideRightControls />

            <ModulesTeacherKPKsPage
                actions={teacherKPKPageActions}
                className="teacher-kpks-page"
                courses={KPKs}
                deleteParamFromQuery={deleteParamFromQuery}
                // важно лишь наличие роли учителя, потому что классы можно позакрывать, но КПК останутся
                haveNoClasses={!isTeacher}
                // для минимизации ремаунтов компонентов, не включаем isLoading,
                // если запрос уже делался до этого и есть данные в KPKsStream
                isLoading={KPKsLoading && !KPKsStream}
                joinCodeProps={joinCodeProps}
                stream={KPKsStream}
            />
        </>
    );
};
